import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      meta:{
        title:'',
		// requireAuth: true,
      },
      component: () =>import ('@/views/index/index.vue')
    }, {
      path: '/minglu',
      name: 'minglu',
      meta:{
        title:'',
		// requireAuth: true,
      },
      component: () =>import ('@/views/minglu/index.vue')
    },{
      path: '/addneeds',
      name: 'addneeds',
      meta:{
        title:'',
		// requireAuth: true,
      },
      component: () =>import ('@/views/needs/index.vue')
    }, {
      path: '/peoplelist',
      name: 'peoplelist',
      meta:{
        title:'',
		// requireAuth: true,
      },
      component: () =>import ('@/views/peoplelist/index.vue')
    },  {
      path: '/peopleinfo',
      name: 'peopleinfo',
      meta:{
        title:'',
		// requireAuth: true,
      },
      component: () =>import ('@/views/peoplelist/info.vue')
    }, {
      path: '/newslist',
      name: 'newslist',
      meta:{
        title:'',
		// requireAuth: true,
      },
      component: () =>import ('@/views/newslist/index.vue')
    },  {
      path: '/newsinfo',
      name: 'newsinfo',
      meta:{
        title:'',
		// requireAuth: true,
      },
      component: () =>import ('@/views/newslist/info.vue')
    }, 
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js